import type { SnapZone } from '@/shared/lib/resolveSnapBounds';

const SNAP_THRESHOLD = 20;

export function detectSnapZone(
  x: number,
  y: number,
  winW: number,
  winH: number,
  parentW: number,
  parentH: number
): SnapZone {
  const canSnapHorizontally = parentW - winW > SNAP_THRESHOLD;
  const canSnapVertically = parentH - winH > SNAP_THRESHOLD;
  const nearLeft = canSnapHorizontally && x <= SNAP_THRESHOLD;
  const nearRight = canSnapHorizontally && x + winW + SNAP_THRESHOLD >= parentW;
  const nearTop = canSnapVertically && y <= SNAP_THRESHOLD;
  const nearBottom = canSnapVertically && y + winH + SNAP_THRESHOLD >= parentH;

  if (nearTop && nearLeft) return 'top-left';
  if (nearTop && nearRight) return 'top-right';
  if (nearBottom && nearLeft) return 'bottom-left';
  if (nearBottom && nearRight) return 'bottom-right';
  if (nearLeft) return 'left';
  if (nearRight) return 'right';
  if (nearTop) return 'top';
  return null;
}

/**
 * el의 padding-box 크기(=clientWidth/Height)를 반환.
 * react-rnd 자식의 (0,0) 은 부모 padding-box 좌상단이며 `bounds='parent'` clamp 도 같은
 * 좌표계다. snap 판정·치수를 content-box(padding 제외)로 잡으면 좌측이 padding-left 만큼
 * 어긋나고 우측에 padding-right 만큼 빈 띠가 남는다. top-snap 의 padding 상쇄 로직은
 * "padding 외부까지 덮는 maximize 행동" 의도이지 좌표계 차이가 아니다.
 */
export function contentBoxSize(el: HTMLElement): { width: number; height: number } {
  return { width: el.clientWidth, height: el.clientHeight };
}
